const flattenMods = (options, config) => {
  const $utils = $nuxt.$store.$utils
  // $utils.log('** flattenMods options', options)
  options.map(o => {
    if (o.mods && config.choices.find(c => c.id === o.choice_id)) {
      o.mods.map(m => {
        if ('modgroup-formation-name' in m.meta) {
          if (!config.choices.find(c => c.id === m.options[0].choice_id)) {
            config.choices.push({ ...m.options[0], id: m.options[0].choice_id, quantity: 1 })
          }
          config.mods.push(m)
        } else if (
          'button-group' in m.meta
          && m.meta['button-group'] === 'true'
          && m.options.length === 3
        ) {
          $utils.log('display as button group')
        } else if (
          'button-group' in m.meta
          && m.meta['button-group'] === 'true'
          && 'button-group-label' in m.meta
          && 'button-group-style' in m.meta
          && m.meta['button-group-style'] === 'super'
        ) {
          $utils.log('display as super', m.meta['button-group-label'])
          config.mods.push(m)
        } else {
          config.mods.push(m)
        }
        config = flattenMods(m.options, config)
      })
    }
  })
  return config
}

const findMod = (choice, mods) => {
  // const $utils = $nuxt.$store.$utils
  let mod = null
  mods.map(m => {
    m.options.map(o => {
      if (!mod) {
        if (choice.id === o.choice_id) {
          mod = m
        } else if (o.mods) {
          mod = findMod(choice, o.mods)
        }
      }
    })
  })
  return mod
}

const resetMods = (choices, option) => {
  const $utils = $nuxt.$store.$utils
  $utils.log('check:', option.name)
  const choiceFound = choices.find(c => c.id === option.choice_id)
  if (choiceFound) {
    $utils.log('remove:', option.name)
    choices.splice(choices.indexOf(choiceFound), 1)
    option.mods.map(m => {
      m.options.map(o => {
        choices = resetMods(choices, o)
      })
    })
  }
  return choices
}

const validateMods = (mods, choices, errors = []) => {
  const $utils = $nuxt.$store.$utils
  mods.map(m => {
    const mandatory = m.selects.mandatory
    const min = m.selects.min
    const max = m.selects.max
    let count = 0
    m.options.map(o => {
      const option = choices.find(c => c.id === o.choice_id)
      if (option) {
        count += option.quantity
        if (o.mods) {
          errors = validateMods(o.mods, choices, errors)
        }
      }
    })
    if (mandatory && !min && !max && count !== 1) {
      errors.push(`${m.name} is required.`)
    }
    $utils.log(m.name, '; count:', count, ', min:', min, ', max:', max)
  })

  return errors
}

// Actions for catering ordering flow
module.exports = {
  addressSearch: async ({ commit, dispatch }, address) => {
    const config = {
      method: 'get',
      url: 'locations',
      params: {
        address
      },
      headers: {
        client_sub: "catering"
      }
    }
    const response = await dispatch('sendRequest', config, { root: true })
    if (response.status === 'ok') {
      commit('locations/setResults', response.data.locations, { root: true })
      commit('locations/setPosition', response.data.position, { root: true })
    }
    commit('locations/setSearched', true, { root: true })
  },
  createCart: async ({ rootState, commit, dispatch }) => {
    if (rootState.location && !rootState.cart) {
      const cartConfig = {
        method: 'post',
        url: `carts`,
        data: {
          menu_id: rootState.location.menu_id
        },
        headers: {
          client_sub: "catering"
        }
      }
      const cartResponse = await dispatch('sendRequest', cartConfig, { root: true })
      if (cartResponse.status !== 'ok') {
        // TODO: Handle error
        commit('setErrors', cartResponse.message, { root: true })
        return false
      }
      cartResponse.data.type = 'catering'
      commit('setCart', cartResponse.data, { root: true })
      return true
    }
    return false
  },
  transferCart: async ({ state, commit, dispatch }, menuId) => {
    if (state.cart) {
      commit('setLoading', true, { root: true })
      const config = {
        method: 'put',
        url: `carts/${state.cart.id}`,
        data: { menu_id: menuId },
      }

      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status !== 'ok') {
        commit('setLoading', false, { root: true })
        commit('setErrors', 'We were not able to transfer your Cart.')
        await dispatch('abandonCart', null, { root: true })
        return false
      } else {
        response.data.type = 'catering'
        await commit('setCart', response.data, { root: true })
      }

      await dispatch('getCart', state.cart.id, { root: true })
      commit('setLoading', false, { root: true })
      return true
    }
    return 'no cart'
  },

  quickAddProduct: async ({ state, rootState, dispatch }, product) => {
    if (!rootState.cart) {
      return await dispatch('addProduct', product)
    }

    if (!Array.isArray(rootState.cart.products)) {
      return await dispatch('addProduct', product)
    }

    const productFound = rootState.cart.products.find(p => p.product_id === product.product_id)
    if (productFound) {
      const updatedProd = {
        id: productFound.id,
        quantity: productFound.quantity + state.quantity ? state.quantity : 1,
        choices: []
      }
      productFound.choices.map(c => {
        updatedProd.choices.push({
          id: c.option_id,
          quantity: 1
        })
      })
      return await dispatch('updateCateringProduct', updatedProd)
    } else {
      return await dispatch('addProduct', product)
    }
  },

  addProduct: async ({ rootState, commit, dispatch }, product) => {
    const $utils = $nuxt.$store.$utils
    if (rootState.product.data) {
      let choices = $utils.copy(rootState.product.choices)
      let mods = rootState.product.data.mods
      const errors = validateMods(mods, choices)
      $utils.log(choices)
      if (errors.length > 0) {
        commit('setErrors', errors, { root: true })
        return false
      }
    }

    commit('setLoading', true, { root: true })
    if (!rootState.cart) {
      if (!await dispatch('createCart', false, { root: true })) {
        commit('setLoading', false, { root: true })
      }
    }

    let payload = {}
    // quick add
    if (product && product.product_id) {
      payload.id = product.product_id
      payload.quantity = 1
    } else {
      payload.id = rootState.product.data.product_id
      payload.quantity = rootState.product.quantity
      payload.choices = rootState.product.choices.map(c => {
        return {
          id: c.id,
          quantity: c.quantity
        }
      })
    }

    if (rootState.product.recipient) {
      payload.recipient = rootState.product.recipient
    }

    if (rootState.product.instructions) {
      payload.instructions = rootState.product.instructions
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'post',
        url: `carts/${rootState.cart.id}/products`,
        data: payload,
        headers: {
          client_sub: "catering"
        }
      }
      const response = await dispatch('sendRequest', config, { root: true })
      if (response.status === 'ok') {
        response.data.type = 'catering'
        commit('setCart', response.data, { root: true })
        commit('product/setAdded', true, { root: true })
        commit('setLoading', false, { root: true })
        return true
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
    return false
  },

  updateCateringProduct: async ({ state, rootState, commit, dispatch }, product) => {
    const $utils = $nuxt.$store.$utils
    if (state.data) {
      const choices = $utils.copy(state.choices)
      const mods = state.data.mods
      const errors = validateMods(mods, choices)
      if (errors.length > 0) {
        commit('setErrors', errors, { root: true })
        return false
      }
    }
    commit('setLoading', true, { root: true })

    if (state.recipient) {
      product.recipient = state.recipient
    }

    if (state.instructions) {
      product.instructions = state.instructions
    }

    if (!product.product_id && rootState.cart && rootState.cart.products) {
      const cartProduct = rootState.cart.products.find((e) => e.id === product.id)
      if (cartProduct) {
        product.product_id = cartProduct.product_id
      }
    }

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'put',
        url: `carts/${rootState.cart.id}/products`,
        data: product,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        const cart = response.data;
        commit('setCart', cart, { root: true })
        commit('setLoading', false, { root: true })
        return true
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
    return false
  },

  removeProduct: async ({ rootState, commit, dispatch }, product) => {
    commit('setLoading', true, { root: true })

    if (rootState.cart && rootState.cart.id) {
      const config = {
        method: 'delete',
        url: `carts/${rootState.cart.id}/products/${product.id}`,
      }

      const response = await dispatch('sendRequest', config, { root: true })

      if (response.status === 'ok') {
        response.data.type = rootState.channel && rootState.channel !== 'default' ? rootState.channel : 'mealtime'
        let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
        events.pushEvent('remove_from_cart', product, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.channel)
        commit('setCart', response.data, { root: true })
      } else {
        let messages = []
        if (typeof response.message === 'string') {
          messages.push(response.message)
        } else if (Array.isArray(response.message)) {
          messages = [...response.message]
        } else {
          messages = response.message
        }
        commit('setErrors', messages, { root: true })
      }
    }
    commit('setLoading', false, { root: true })
  },

  viewProduct: async ({ commit, rootState }, product) => {
    let tracking = rootState.appInfo.library_tracking === false || rootState.appInfo.library_tracking === true ? rootState.appInfo.library_tracking : true
    events.pushEvent('view_item', product, window, rootState.location, rootState.cart, rootState.user, tracking, rootState.channel)
    commit('setProduct', product);
  },
  clearProduct: async ({ commit }) => {
    commit('setProduct', null);
  },
}